// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteModel {
    static getAttributeTypeMap() {
        return SiteModel.attributeTypeMap;
    }
}
SiteModel.discriminator = undefined;
SiteModel.additionalProperties = false;
SiteModel.attributeTypeMap = [
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number"
    },
    {
        "name": "externalIds",
        "baseName": "externalIds",
        "type": "Array<SiteSharedExternalIdModel>"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<SiteSharedAddressModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<SiteSharedPhoneModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<SiteSharedEmailAddressModel>"
    },
    {
        "name": "contactPreferences",
        "baseName": "contactPreferences",
        "type": "Array<SiteSharedContactPreferenceModel>"
    },
    {
        "name": "procurementMethods",
        "baseName": "procurementMethods",
        "type": "Array<SiteProcurementMethodModel>"
    },
    {
        "name": "globalIds",
        "baseName": "globalIds",
        "type": "Array<SiteSharedGlobalIdModel>"
    },
    {
        "name": "siteRoleType",
        "baseName": "siteRoleType",
        "type": "RoleType"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "nickName",
        "baseName": "nickName",
        "type": "string"
    },
    {
        "name": "businessStartTime",
        "baseName": "businessStartTime",
        "type": "Date"
    },
    {
        "name": "businessEndTime",
        "baseName": "businessEndTime",
        "type": "Date"
    },
    {
        "name": "siteNote",
        "baseName": "siteNote",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "stateTaxId",
        "baseName": "stateTaxId",
        "type": "string"
    },
];
//# sourceMappingURL=siteModel.js.map